import React from 'react'
import AboutTemplate from '../../templates/About/AboutTemplate'

const About = () => {
  return (
     <AboutTemplate />
  )
}

export default About